<div class="theme-switcher">
  <!-- Dark Mode Toggle -->
  <button
    mat-icon-button
    (click)="toggleDarkMode()"
    [matTooltip]="(isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode')"
    matTooltipPosition="below"
    class="mode-toggle">
    <mat-icon>{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
  </button>

  <!-- Theme Selector Menu -->
  <button
    mat-icon-button
    [matMenuTriggerFor]="themeMenu"
    matTooltip="Change Theme"
    matTooltipPosition="below"
    class="theme-menu-button">
    <mat-icon>palette</mat-icon>
  </button>

  <mat-menu #themeMenu="matMenu" class="theme-menu">
    <div class="theme-menu-header">
      <span class="theme-menu-title">Select Theme</span>
    </div>
    <button
      mat-menu-item
      *ngFor="let theme of availableThemes"
      (click)="selectTheme(theme.name)"
      [class.active]="(currentTheme$ | async) === theme.name">
      <mat-icon>{{ (currentTheme$ | async) === theme.name ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
      <span>{{ theme.displayName }}</span>
    </button>
  </mat-menu>
</div>
